import { createSlice ,PayloadAction } from "@reduxjs/toolkit";

interface CompanyInfo {
    companyName: string;
    residentialAddress: string;
    city: string;
    state: string;
    zipCode: string;
}


interface FormState {
    companyInfo:CompanyInfo;
    activeStep:number;
    stepStatusArray:('completed'|'default')[];
}

const initialState: FormState ={
    companyInfo:{
        companyName: '',
        residentialAddress: '',
        city: '',
        state: '',
        zipCode: '',
    },
    activeStep:0,
    stepStatusArray:['default','default','default'],
}


const formSliceStepOne= createSlice({
    name:"forms",
    initialState,
    reducers:{
        setCompanyInfo(state,action:PayloadAction<CompanyInfo>){
            state.companyInfo = action.payload;
        },
        setActiveStep(state,action:PayloadAction<number>){
            state.activeStep = action.payload;
        },
        setStepStatusArray(state,action:PayloadAction<('completed'|'default')[]>){
            state.stepStatusArray = action.payload;
        },
        updateStepStatus(state,action:PayloadAction<number>){
            const stepIndex = action.payload;
            const newStatus = [...state.stepStatusArray];
            newStatus[stepIndex] = 'completed';
            if (stepIndex + 1 < newStatus.length) {
                    newStatus[stepIndex + 1] = 'default';
                }
                state.stepStatusArray =newStatus;
                state.activeStep =stepIndex + 1;
            },
            goBackStep(state,action:PayloadAction<number>){
             const stepIndex = action.payload;
            const newStatus = [...state.stepStatusArray];
            newStatus[stepIndex] = 'default';
            if (stepIndex - 1 >0) {
                    newStatus[stepIndex - 1] = 'completed';
                }
                state.stepStatusArray =newStatus;
                state.activeStep =stepIndex - 1;
            }
        }
    },
);

export const {setCompanyInfo,setActiveStep,setStepStatusArray,updateStepStatus,goBackStep} = formSliceStepOne.actions;
export default formSliceStepOne.reducer;
 